export var DocumentUploaderStatus;
(function (DocumentUploaderStatus) {
    DocumentUploaderStatus[DocumentUploaderStatus["UPLOADING"] = 0] = "UPLOADING";
    DocumentUploaderStatus[DocumentUploaderStatus["UPLOADED"] = 1] = "UPLOADED";
    DocumentUploaderStatus[DocumentUploaderStatus["ERROR"] = 2] = "ERROR";
})(DocumentUploaderStatus || (DocumentUploaderStatus = {}));
